const AccountPage = () => {
  return <div></div>;
};

export default AccountPage;
